import { useState, useEffect } from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';
import * as dayjs from 'dayjs'

const PROG = 'ChartTransactionValuePerDayByBranch.js';
const BRANCH_COLORS = ['#369fe3', '#20c997', '#f59f00', '#e67700', '#845ef7', '#15aabf', '#fa5252', '#82ca9d', '#5c7cfa', '#adb5bd'];

const ChartTransactionValuePerDayByBranch = (props) => {

  const [chartData, setChartData] = useState(null);
  const [branches, setBranches] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    loadChartData();
  }, [props.timeRange]);

  const loadChartData = async () => {
    const FUNCTION = 'loadChartData';
    try {
      setIsLoadingData(true);
      const _chartDataResponse = await apiComms.getChartDataTransactionValuePerDayByBranch(props.timeRange);
      if (_chartDataResponse && !_chartDataResponse.isErr) {
        const _chartData = _chartDataResponse.response.chartdata;
        const _branches = _chartDataResponse.response.branches ?? [];
        const _chartDataDateParsed = _parseChartDataDates(_chartData, _branches);
        setBranches(_branches);
        setChartData(_chartDataDateParsed);
      }
      setIsLoadingData(false);
    }
    catch (e) {
      logger.error('Exception Occured', { PROG, FUNCTION });
      console.log('Exception: '+e+', '+e.stack);
    }
  };

  const _parseChartDataDates = (_chartData, _branches) => {
    let _parsedChartData = [];
    _chartData.forEach((_chartDataRec) => {
      const _chartDateEpoch = (_chartDataRec.x*1000);
      const _chartDateDayJs = dayjs(_chartDateEpoch);
      const _chartDateReadable = _chartDateDayJs.format('DD/MMM/YYYY');
      const _parsedChartRec = {
        date : _chartDateReadable
      };

      _branches.forEach((_branchCode) => {
        _parsedChartRec[_branchCode] = Number(_chartDataRec[_branchCode] ?? 0);
      });

      _parsedChartData.push(_parsedChartRec);
    });

    return _parsedChartData;
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 280 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <AreaChart
                data={chartData}
                margin={{ top: 20, right: 20, left: 10, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  angle={45}
                  textAnchor="start"
                  height={60}
                  tick={{ fontSize: 10 }}
                />
                <YAxis width={58} />
                <Tooltip formatter={ (value) => `EUR ${Number(value).toFixed(2)}` } />
                <Legend />
                { branches.map((branchCode, index) => {
                  const color = BRANCH_COLORS[index % BRANCH_COLORS.length];
                  return (
                    <Area
                      key={ branchCode }
                      type="monotone"
                      dataKey={ branchCode }
                      stackId="branches"
                      stroke={ color }
                      fill={ color }
                      fillOpacity={0.75}
                      name={ branchCode }
                    />
                  );
                })}
              </AreaChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Loyalty Customer Transaction Value Per Day By Branch
        </div>
      </div>
    </div>
  );
};

export default ChartTransactionValuePerDayByBranch;
